import CardLibraryComponent from '../components/views/CardLibrary';
import CardTemplateComponent from '../components/views/CardTemplate';
import DashboardComponent from '../components/views/Dashboard';
import ErrorComponent from '../components/views/Error';
import LoggedInComponent from '../components/layouts/LoggedIn';
import LoggedOutComponent from '../components/layouts/LoggedOut';
import LoginComponent from '../components/views/Login';
import MediaLibraryComponent from '../components/views/MediaLibrary';
import MediaTemplateComponent from '../components/views/MediaTemplate';
import MediaLibraryLibraryComponent from '../components/views/MediaLibraryLibrary';
import MediaLibraryEditorComponent from '../components/views/MediaLibraryEditor';
import NotFoundComponent from '../components/views/NotFound';
import OnboardTeamComponent from '../components/views/OnboardTeam';
import OnboardUserComponent from '../components/views/OnboardUser';
import MarketLibraryComponent from '../components/views/MarketLibrary';
import MarketEditorComponent from '../components/views/MarketEditor';
import ProductLibraryComponent from '../components/views/ProductLibrary';
import ProductEditorComponent from '../components/views/ProductEditor';
import ProductGroupLibraryComponent from '../components/views/ProductGroupLibrary';
import ProductGroupEditorComponent from '../components/views/ProductGroupEditor';
import PolicyLibraryComponent from '../components/views/PolicyLibrary';
import UserLibraryComponent from '../components/views/UserLibrary';
import InteractionTypesComponent from '../components/views/InteractionTypes';
import PolicyNewComponent from '../components/views/PolicyNew';
import PolicyTemplateComponent from '../components/views/PolicyTemplate';
import RegisterTeamComponent from '../components/views/RegisterTeam';
import RegisterUserComponent from '../components/views/RegisterUser';
import ResetPasswordComponent from '../components/views/ResetPassword';
import Router from 'vue-router';
import SearchMediaLibraryComponent from '../components/views/SearchMediaLibrary';
import SequenceLibraryComponent from '../components/views/SequenceLibrary';
import SequenceTemplateComponent from '../components/views/SequenceTemplate';
import TenantSettingsComponent from '../components/views/TenantSettings';
import Vue from 'vue';
import store from '../store';

Vue.use(Router);

const router = new Router({
    'mode': 'history',
    'base': __dirname,
    'linkActiveClass': 'active',
    'routes': [
        /**
         * Core routes
         */
        {
            'path': '/',
            'component': LoggedOutComponent,
            // Change redirect to checking for token beforeEnter
            'redirect': '/login',
            'children': [
                {
                    'path': '/login',
                    'component': LoginComponent,
                    'name': 'login'
                },
                {
                    'path': '/register/team',
                    'component': RegisterTeamComponent,
                    'name': 'registerTeam'
                },
                {
                    'path': '/register/user',
                    'component': RegisterUserComponent,
                    'name': 'registerUser'
                },
                {
                    'path': '/reset/:tokenId?',
                    'component': ResetPasswordComponent,
                    'name': 'resetPassword'
                }
            ]
        },
        // Authenticated routes
        {
            'path': '/',
            'component': LoggedInComponent,
            'redirect': '/',
            'children': [
                {
                    'path': '/dashboard',
                    'component': DashboardComponent,
                    'name': 'dashboard'
                },
                {
                    'path': '/media',
                    'component': MediaLibraryComponent,
                    'name': 'mediaLibrary'
                },
                {
                    'path': '/media/:mediaId',
                    'component': MediaTemplateComponent,
                    'name': 'mediaTemplate'
                },
                {
                    'path': '/search/media',
                    'component': SearchMediaLibraryComponent,
                    'name': 'mediaSearch'
                },
                {
                    'path': '/media-libraries',
                    'component': MediaLibraryLibraryComponent,
                    'name': 'mediaLibraryLibrary'
                },
                {
                    'path': '/media-libraries/:mediaLibraryId',
                    'component': MediaLibraryEditorComponent,
                    'name': 'mediaLibraryEditor'
                },
                {
                    'path': '/cards',
                    'component': CardLibraryComponent,
                    'name': 'cardLibrary'
                },
                {
                    'path': '/cards/:shortId',
                    'component': CardTemplateComponent,
                    'name': 'cardTemplate'
                },
                {
                    'path': '/policies',
                    'component': PolicyLibraryComponent,
                    'name': 'policyLibrary'
                },
                {
                    'path': '/interaction-types',
                    'component': InteractionTypesComponent,
                    'name': 'interactionTypes'
                },
                {
                    'path': '/policies/create',
                    'component': PolicyNewComponent,
                    'name': 'policyNew'
                },
                {
                    'path': '/policies/:shortId',
                    'component': PolicyTemplateComponent,
                    'name': 'policyTemplate'
                },
                {
                    'path': '/sequences',
                    'component': SequenceLibraryComponent,
                    'name': 'sequenceLibrary'
                },
                {
                    'path': '/sequences/create',
                    'component': SequenceTemplateComponent,
                    'name': 'sequenceTemplate',
                    'props': {
                        'newSequence': true
                    }
                },
                {
                    'path': '/sequences/:shortId',
                    'component': SequenceTemplateComponent,
                    'name': 'sequenceTemplate',
                    'props': {
                        'newSequence': false
                    }
                },
                {
                    'path': '/products',
                    'component': ProductLibraryComponent,
                    'name': 'productLibrary'
                },
                {
                    'path': '/products/:productId',
                    'component': ProductEditorComponent,
                    'name': 'productEditor'
                },
                {
                    'path': '/product-groups',
                    'component': ProductGroupLibraryComponent,
                    'name': 'productLibrary'
                },
                {
                    'path': '/product-groups/:productGroupId',
                    'component': ProductGroupEditorComponent,
                    'name': 'productGroupEditor'
                },
                {
                    'path': '/settings',
                    'component': TenantSettingsComponent,
                    'name': 'settings',
                    'props': {}
                },
                {
                    'path': '/markets',
                    'component': MarketLibraryComponent,
                    'name': 'marketLibrary'
                },
                {
                    path: '/markets/:marketId',
                    component: MarketEditorComponent,
                    name: 'marketEditor'
                },
                {
                    path: '/users',
                    component: UserLibraryComponent,
                    name: 'userLibrary'
                }
            ]
        },
        {
            'path': '/error',
            'component': ErrorComponent,
            'name': 'error',
            'meta': {

            }
        },
        {
            'path': '*',
            'redirect': '/login'
        }
    ]
});

router.afterEach((to,from) => {
    window.Intercom("update");
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js